<script>
export default {
  name: "ActionComponent",
  props: {
    deleteCartItemHandler: {
      type: Function,
      required: true
    },
    localStorageIndex: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div class="action">
    <button class="btn btn-custom" @click="deleteCartItemHandler(localStorageIndex)">
      <font-awesome-icon icon="trash" />
    </button>
  </div>
</template>

<style scoped>

.action {
  display: inline-block;
  vertical-align: middle;
}

.action {
  width: 15%;
  text-align: right;
}

</style>
